export default {"src":"/_next/static/media/domestic.cef1c7d6.svg","height":417,"width":471};